export default __webpack_public_path__ + "static/media/logo.bc82c113.png";